module.exports = __webpack_public_path__ + "img/pattern-top.fecd5697.svg";